import type { HttpClient } from '@angular/common/http';
import { Directive, ViewChild } from '@angular/core';

import type { CargaArchivoService } from 'app/carga-archivo/service/carga-archivo.service';
@Directive()
export abstract class PanelBulkLoadComponent {
  @ViewChild('modalFileLoad') modalFileLoad: any;
  @ViewChild('modalSuccess') modalSuccess: any;
  @ViewChild('modalLoadResult') modalLoadResult: any;

  loadRegisterSpinner = false;
  fileLoaded = false;
  fileSelected = true;

  title: string;

  markListFile: any;
  fileName: string;
  format: string;
  urlGenerated: string;
  messageModal: string;
  modalTitle: string;
  loadResultData: any;

  constructor(
    public readonly cargaArchivoService: CargaArchivoService,
    public readonly http: HttpClient,
    public readonly excelTemplate: string,
    public readonly fileTitle: string
  ) {}

  public verifyFile(fileRegister: File): boolean {
    if (!fileRegister) return true;
    const extension = fileRegister.name.split('.').pop().toLowerCase();
    if (!['xlsx'].includes(extension)) return true;
    this.format = extension;
    return false;
  }

  public onFileSelected(fileSelected): void {
    for (const file of fileSelected.files) {
      this.markListFile = file;
    }
    this.fileSelected = false;
  }

  public downloadTemplate() {
    this.http.get(this.excelTemplate, { responseType: 'blob' }).subscribe(
      (data: Blob) => {
        const downloadURL = window.URL.createObjectURL(data);
        const link = document.createElement('a');
        link.href = downloadURL;
        link.download = this.fileTitle;
        link.click();
        window.URL.revokeObjectURL(downloadURL);
      },
      error => {
        console.error('Error al descargar el archivo', error);
      }
    );
  }

  public loadExecutionProcessFile(id: any): void {
    this.cargaArchivoService.getProcessStatus(id).subscribe(data => {
      if (data.status === 3) {
        this.modalFileLoad.hide();
        this.messageModal = 'successLoadFile';
        this.modalTitle = 'Carga de Archivo';
        this.modalSuccess.show();
        this.loadRegisterSpinner = false;
        this.fileLoaded = true;
      } else if (data.status === 4) {
        this.modalLoadResult.show();
        this.loadRegisterSpinner = false;
        this.loadResultData = JSON.parse(data.output_data);
      } else {
        setTimeout(() => {
          this.loadExecutionProcessFile(data.id);
        }, 2000);
      }
    });
  }

  // abstract loadExecutionProcessFile(id: any): void;

  // Carga de documentos a S3
  abstract loadRegisterFile(): void;
}
